/* eslint-disable */
import _ from 'underscore';
import * as _SharedEditorView from '@bingads-webui-campaign-legacy/adextension-shared/view/extension-editor';
import * as CxSelect from '@bingads-webui-campaign-legacy/adextension-structuredsnippet/view/adapt-cxSelect';
import * as StringListInput from '@bingads-webui-campaign-legacy/adextension-structuredsnippet/view/adapt-string-list-input';
var schema = window.globalLegacySchema.get('StructuredSnippetAdExtension');
var i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/adextensions');
var SharedEditorView = _SharedEditorView.default;
var EditorView = SharedEditorView.extend({
  initialize: function (options) {
    options = _.defaults({
      schema: schema,
      fields: [{
        property: 'Category',
        control: CxSelect.default
      }, {
        property: 'Texts',
        control: StringListInput.default,
        validators: {
          size: {
            message: i18n.get('StructuredSnippet_Texts_Size_Invalid_Message')
          }
        }
      }],
      customValidators: {
        Texts: {
          isValid: function (values) {
            var len = _.chain(values).uniq().size().value();
            return len === _.size(values);
          },
          message: i18n.get('StructuredSnippet_Texts_Duplicate_Invalid_Message')
        }
      }
    }, options);
    options.extension = options.extension || ({
      Category: 'Amenities'
    });
    SharedEditorView.prototype.initialize.call(this, options);
  }
});
export default EditorView;

